import CustomTypography from "../../../Components/Typography";
import Box from "@mui/material/Box";
import InputField from "../../../Components/InputField";
import muiStyles from "../styles/muiStyles";
import { useFormikContext } from "formik";
import { Card } from "@mui/material";
import ImageUploader from "../../../Components/ImageUploader";
import { useTranslation } from "react-i18next";

const IMAGE_FIELDS = [
  {
    type: "services",
    labelKey: "services_image",
    urlField: "servicesImageUrl",
    tempField: "_servicesImageTempFile",
    deletedField: "_servicesImageDeleted",
    initialField: "_servicesImageInitialUrl",
  },
  {
    type: "store",
    labelKey: "store_image",
    urlField: "storeImageUrl",
    tempField: "_storeImageTempFile",
    deletedField: "_storeImageDeleted",
    initialField: "_storeImageInitialUrl",
  },
  {
    type: "restaurant",
    labelKey: "restaurant_image",
    urlField: "restaurantImageUrl",
    tempField: "_restaurantImageTempFile",
    deletedField: "_restaurantImageDeleted",
    initialField: "_restaurantImageInitialUrl",
  },
];

const MakeBusinessShine = ({ isloading, setSubmitStatus }) => {
  const { t } = useTranslation("page-business-settings", "dropdowns");
  const { handleChange, values, setFieldValue } = useFormikContext();

  const handleImageError = (message) => {
    setSubmitStatus({
      open: true,
      message: message || t("image_upload_failed"),
      severity: "error",
    });
  };

  const { cardStyles } = muiStyles;

  return (
    <Card sx={cardStyles}>
      <CustomTypography type="subheading">
        {t("make_your_business_shine")}
      </CustomTypography>

      <Box sx={{ py: "32px" }}>
        <InputField
          name="description"
          label={t("business_description_label")}
          value={values.description || ""}
          onChange={handleChange}
          placeholder={t("business_description_placeholder")}
          disabled={isloading}
          multiline
          minRows={3}
          maxRows={4}
          maxLength={200}
        />
      </Box>

      <Box
        sx={{
          display: "grid",
          // Content-width columns so the three images sit close to each other
          // instead of spreading across the full card width.
          gridTemplateColumns: { xs: "1fr", sm: "auto auto auto" },
          justifyContent: "start",
          alignItems: "start",
          columnGap: "56px",
          rowGap: "24px",
        }}
      >
        {IMAGE_FIELDS.map((field) => (
          <ImageUploader
            key={field.type}
            label={t(field.labelKey)}
            imageUrl={values[field.urlField]}
            setImageUrl={(url) => setFieldValue(field.urlField, url)}
            tempImageFile={values[field.tempField]}
            setTempImageFile={(file) => setFieldValue(field.tempField, file)}
            onError={handleImageError}
            isLoading={isloading}
            maxSizeMB={15}
            hint={t("upload_logo_hint")}
            imageStyle={{
              width: 110,
              height: 110,
              borderRadius: "50%",
              objectFit: "cover",
            }}
            initialImageUrl={values[field.initialField]}
            onImageDelete={() => setFieldValue(field.deletedField, true)}
            resetImageDeleted={() => setFieldValue(field.deletedField, false)}
          />
        ))}
      </Box>
    </Card>
  );
};

export const BUSINESS_IMAGE_FIELDS = IMAGE_FIELDS;

export default MakeBusinessShine;
